import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { Pagination } from '@mui/material';
import axios from 'axios';
import { CiEdit } from "react-icons/ci";
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { showTableResponse } from '../common-helpers/commonServices';
import IGPClassesModal from './IGPClassesModal';

const IGPClasses = () => {
    const childRef = useRef();
    const [blogs, setBlogs] = useState([]);
    const [blogCategories, setBlogCategories] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(blogs);
    const [loadDownloads, setDownloadsLoading] = useState(false);
    console.log(blogCategories);

    // search functionality    
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        const filteredBatches = blogs?.filter(
            item => item?.title?.toLowerCase().includes(searchTerm?.toLowerCase())
        );
        setChecked(filteredBatches)
    }, [searchTerm])
    const handleSearch = (e) => {
        setSearchTerm(e.target.value)
    }

    //set Table data
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/getIGPClasses').then((res) => {
            console.log(res.data.data)
            let blogs = res.data.data;
            setBlogs(blogs);
            setChecked(blogs);
        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message);
        })
    }, [loadDownloads])

    const pageSize = 50;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)
    //handle delete course


    const handlePageChange = (e, p) => {
        setCurrentPage(parseInt(p));
    }


    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className=' col-8 d-flex justify-content-between'>
                                    <div className="col-sm-4">
                                        <button type="button" className="btn btn-dark btn-sm me-2"
                                            onClick={() => childRef.current.openModal()}
                                        >
                                            + Add
                                        </button>
                                    </div>
                                    <div className="col-sm-4">

                                    </div>
                                    <div className="col-sm-4">
                                    </div>

                                </div>

                                <div className="input-group search-area mb-md-0 mb-3">
                                    <input type="text" className="form-control" onChange={handleSearch} value={searchTerm} placeholder="Search here..." />
                                    <span className="input-group-text"><Link to={"#"}>
                                        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF" />
                                        </svg>
                                    </Link></span>
                                </div>
                            </div>

                        </div>
                        <div className=" d-sm-flex text-center justify-content-between align-items-center">

                            <div className='dataTables_info text-dark'>
                                Records: {checked.length}
                            </div>
                            <div className=" col-7 dataTables_paginate paging_simple_numbers d-flex justify-content-end align-items-center  mb-0 pt-2"
                                id="example-student_wrapper">

                                <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={handlePageChange} />
                            </div>
                        </div>
                        <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                            <div className="dataTables_wrapper no-footer">

                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">

                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }}>
                                            <tr className='text-center text-dark border border-left'>
                                                <th className=' custom-table-header  p-2'>SN</th>

                                                <th className='p-2  custom-table-header text-start '>SUBJECTS/TOPICS</th>
                                                <th className='p-2  custom-table-header text-start '>NO. OF SESSIONS</th>
                                                <th className=' custom-table-header  p-2' >DOWNLOADS</th>
                                                {/* <th className=' text-start custom-table-header  p-2' >TITLE HEADING</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    <td className='text-center p-1 column-width' style={{ border: "1px solid #cccccc", width: "65px" }} ><h6 className="text-primary  mb-0 fw-bold"> {ind + 1}</h6></td>

                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Subjects}{' '}
                                                                <CiEdit cursor='pointer' title='Edit Blogs' size={18} className='ms-3' onClick={() => childRef.current.openModal(item)} />
                                                                {/* <MdDeleteOutline color="red" title='Delete Blogs' cursor='pointer' size={18} className='ms-2' onClick={() => { handleDeleteBatches(item.id) }}
                                                                /> */}
                                                            </h6>
                                                        </div>
                                                    </td>
                                                    <td className='text-center p-1 column-width' style={{ border: "1px solid #cccccc", width: "65px" }} ><h6 className="text-primary  mb-0"> {item.SessionCount}</h6></td>
                                                    <td className="p-1 text-center" style={{ border: "1px solid #ccc", width: "10rem" }}>
                                                        <button onClick={() => window.open(item.Downloads)} className="btn btn-xs btn-info">Click Here</button>
                                                    </td>

                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(blogs, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <IGPClassesModal ref={childRef} loadDownloads={loadDownloads} setDownloadsLoading={setDownloadsLoading} />
        </>
    )
}

export default IGPClasses;